import { render, staticRenderFns } from "./ServerBanks.vue?vue&type=template&id=6071f002&"
import script from "./ServerBanks.vue?vue&type=script&lang=js&"
export * from "./ServerBanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports